import {
  validateRequired,
  validationObject,
  validatePhoneNumber,
} from 'utils/validations';

export const initialValues = data => {
  const {
    regionName,
    name,
    contact,
    imageUrl,
    bookingPhone,
    operationPhone,
    address,
  } = data;

  return {
    regionName,
    name,
    address,
    image: imageUrl,
    bookingPhoneCountry: bookingPhone.country,
    bookingPhone: bookingPhone.number,
    operationPhone: operationPhone.number,
    operationPhoneCountry: operationPhone.country,
    ...(contact && { contact: contact.general.email }),
  };
};

export const validationSchema = validationObject({
  image: validateRequired(),
  bookingPhone: validatePhoneNumber(),
  operationPhone: validatePhoneNumber(),
});

export const generalSection = ({ countries }) => [
  {
    field: 'name',
    type: 'text',
    label: 'Company Name',
    required: true,
    size: 'half',
    disabled: true,
  },
  {
    field: 'regionName',
    type: 'text',
    label: 'Region',
    required: true,
    size: 'half',
    disabled: true,
  },
  {
    field: 'contact',
    type: 'text',
    label: 'Contact',
    required: true,
    size: 'half',
    disabled: true,
  },
  {
    field: 'bookingPhone',
    type: 'phone',
    label: 'Booking Phone',
    required: true,
    size: 'half',
    disabled: false,
    placeholder: 'Enter phone number',
    secondaryOptions: countries,
    secondaryKey: 'bookingPhoneCountry',
  },
  {
    field: 'operationPhone',
    type: 'phone',
    label: 'Operation Phone',
    required: true,
    size: 'half',
    disabled: false,
    placeholder: 'Enter phone number',
    secondaryOptions: countries,
    secondaryKey: 'operationPhoneCountry',
  },
  {
    field: 'address',
    required: false,
    label: 'Address',
    type: 'address',
    size: 'half',
    maxLength: 250,
  },
];
